<template>
  <div class="animated fadeIn">
    <StyledDialog>
      <div slot="header">
        <h2>{{client.location_edit.Name}}</h2>
      </div>
      <div slot="details">
        <div>{{client.location_edit.Address1}} {{client.location_edit.Address2}}</div>
        <div>{{client.location_edit.City }}</div>
      </div>
      <span slot="entityType">location</span>
    </StyledDialog>
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Legal Name</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="client.client_edit.LegalName"
                    placeholder="Legal Name"
                    required
                    type="text"
                    autocomplete="company"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-registered"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Common Name</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="client.client_edit.CommonName"
                    required
                    placeholder="Common Name"
                    type="text"
                    autocomplete="company"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-star"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Email (primary)</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="client.client_edit.Email1"
                    placeholder="Primary Email Address"
                    required
                    type="email"
                    autocomplete="email"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-envelope"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Email (secondary)</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="client.client_edit.Email2"
                    placeholder="Alternate Email Address"
                    type="email"
                    autocomplete="email"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-envelope"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Phone</b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-input
                    v-model="client.client_edit.Phone1"
                    placeholder="Phone Number"
                    required
                    type="text"
                    v-mask="'(###) ###-####'"
                    autocomplete="phone1"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-phone"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Mobile</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="client.client_edit.Phone2"
                    placeholder="Cell Phone Number"
                    type="text"
                    v-mask="'(###) ###-####'"
                    autocomplete="phone2"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-phone"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text>Website</b-input-group-text>
                  </b-input-group-prepend>

                  <b-form-input
                    v-model="client.client_edit.Website"
                    placeholder="Website"
                    required
                    type="text"
                    autocomplete="website"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-input-group-text>
                      <i class="fa fa-globe"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col md="12">
              <b-card header-tag="header" footer-tag="footer">
                <div>
                  <b-btn v-b-toggle.collapse1 variant="ghost-primary">Locations ({{LocationCount}})</b-btn>
                  <b-collapse id="collapse1" class="mt-2">
                    <b-list-group>
                      <LocationRow
                        v-for="location in client.client_edit.Locations"
                        :key="location.LocationID"
                        :location="location"
                      />
                    </b-list-group>
                  </b-collapse>
                </div>
              </b-card>
            </b-col>
          </b-row>-->
          <b-row>
            <b-col md="12">
              <b-card>
                <div slot="header">
                  <a v-b-toggle.collapse2 style="cursor:pointer;">
                    <i class="fa fa-caret-down fa-lg mr-2" v-if="seen" @click="toggleVisibility" />
                    <i class="fa fa-caret-up fa-lg mr-2" v-if="!seen" @click="toggleVisibility" />
                    <span v-if="seen" @click="toggleVisibility">More</span>
                    <span v-if="!seen" @click="toggleVisibility">Less</span>
                  </a>
                </div>
                <b-collapse id="collapse2" class="mt-2">
                  <b-tabs>
                    <b-tab active>
                      <template slot="title">
                        <i class="fa fa-map-marker fa-lg"></i>
                        <span class="ml-1">Locations</span>
                      </template>
                      <br />
                      <b-list-group>
                        <LocationRow
                          v-for="location in client.client_edit.Locations"
                          :key="location.LocationID"
                          :location="location"
                        />
                      </b-list-group>
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-address-card"></i>
                        <span class="ml-1">Contacts</span>
                      </template>
                      <br />
                      <b-list-group>
                        <ContactRow
                          v-for="contact in client.client_edit.Contacts"
                          :key="contact.ContactID"
                          :contact="contact"
                        />
                      </b-list-group>
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-file"></i>
                        <span class="ml-1">Accounting</span>
                      </template>
                      <br />ADD: perhaps info here for outstanding quotes, billing, recent jobs etc... discuss
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-cog"></i>
                        <span class="ml-1">Setup</span>
                      </template>
                      <br />ADD: Account Rep, sales rep, commission rate? discuss with team
                    </b-tab>
                  </b-tabs>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <div class="form-group form-actions" style="float:right;">
            <b-button
              class="mr-2 mt-2"
              type="submit"
              size="md"
              variant="outline-primary"
              @click="back"
            >
              <!-- <i class="fa fa-close"></i> -->
              Cancel
            </b-button>
            <b-button class="mr-0 mt-2" type="submit" size="md" variant="primary">
              <i class="fa fa-save"></i>
              Save
            </b-button>
          </div>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import LocationRow from "@/components/CustomRowComponents/LocationRow.vue";
import ContactRow from "@/components/CustomRowComponents/ContactRow.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "ClientProfile",
  data() {
    return {
      selected: [], // Must be an array reference!
      show: true,
      seen: true
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    }
  },
  computed: {
    ...mapState(["client"]),
    ...mapGetters("client", ["LocationCount"])
  },
  components: {
    LocationRow,
    ContactRow,
    StyledDialog
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
